import {API_DRIVER} from "../config/axios";

export interface IUpdateUserRequest {
    address: string
    city: string
    phone_number: string
    subscribed: boolean
}

export interface ISendNotificationRequest {
    select_all?: boolean
    search_text?: string
    wish_id?: string
    title_en: string
    title_mk: string
    title_al: string
    content_en: string
    content_mk: string
    content_al: string
    link?: string
    users?: { [key: string]: string }
}

export interface ISendEmailsRequest {
    select_all?: boolean
    search_text?: string
    wish_id?: string
    subject_en: string
    subject_mk: string
    subject_al: string
    content_en: string
    content_mk: string
    content_al: string
    subscribed?: boolean
    users?: string[]
}

const getUsersRequestUrl = (endpointUrl: string) => {
    return `/api/users${endpointUrl}`
}

const UserService = {
    fetchLoggedInUserDetails: (token: string) => {
        return API_DRIVER.get(getUsersRequestUrl('/me'), {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
    },
    updateUserDetails: (body: IUpdateUserRequest, image: File | undefined) => {
        const formData = new FormData()
        formData.append("user_update", JSON.stringify(body))
        if (image) {
            formData.append("profile_picture", image)
        }
        return API_DRIVER.patch(getUsersRequestUrl('/update'), formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
    },
    fetchLeaderboard: () => {
        return API_DRIVER.get(getUsersRequestUrl('/leaderboard'))
    },
    updateLocale: (locale: string) => {
        return API_DRIVER.patch(getUsersRequestUrl('/update-locale'), {}, {
            params: {
                locale
            }
        })
    },
    spinTheWheel: () => {
        return API_DRIVER.post(getUsersRequestUrl('/points/spin-wheel'))
    },
    unsubscribeNewsletter: (userEmailHex: string) => {
        return API_DRIVER.patch(getUsersRequestUrl(`/unsubscribe`), {}, {
            params: {
                user_email_hex: userEmailHex
            }
        })
    },
    fetchUsers: (page: number, size: number, searchText: string, wishId: string | undefined, subscribed: boolean, onlyWithUser: boolean) => {
        return API_DRIVER.get(getUsersRequestUrl(''), {
            params: {
                offset: page,
                limit: size,
                search_text: searchText,
                wish_id: wishId,
                subscribed,
                only_with_user: onlyWithUser
            }
        })
    },
    sendNotification: (body: ISendNotificationRequest) => {
        return API_DRIVER.post(getUsersRequestUrl('/send-notification'), body)
    },
    fetchPreviousLeaderboard: () => {
        return API_DRIVER.get(getUsersRequestUrl('/leaderboard/previous-months'))
    },
    redeemGiftCoupon: (code: string) => {
        return API_DRIVER.put(getUsersRequestUrl('/redeem-coupon'), undefined, {
            params: {
                code_hex: code
            }
        })
    },
    sendEmails: (body: ISendEmailsRequest) => {
        return API_DRIVER.post(getUsersRequestUrl('/send-emails'), body)
    },
    subscribeNewsletter: (email: string) => {
        return API_DRIVER.put(getUsersRequestUrl('/subscribe-email-newsletter'), undefined, {
            params: {
                email
            }
        })
    },
    getPointsHistory: (page: number, limit: number) => {
        return API_DRIVER.get(getUsersRequestUrl('/points-history'), {
            params: {
                offset: page,
                limit
            }
        })
    },
    deleteUser: (userId: string) => {
        return API_DRIVER.delete(getUsersRequestUrl(`/${userId}`))
    }
}

export default UserService
